import React from 'react';
import { VERSION } from '../../version';

export const VersionInfo: React.FC = () => {
  return (
    <div className="fixed bottom-2 right-2 text-xs text-gray-500">
      <div title={`Build Time: ${VERSION.buildTime}`}>
        Version: {VERSION.buildNumber}
      </div>
      <div className="text-[10px]">
        {VERSION.commitHash.substring(0, 7)}
      </div>
    </div>
  );
};
